import React from "react";
import {
  Card,
  Row,
  Col,
  Typography,
  Upload,
  Button,
  Input,
} from "antd";

import { PlusCircleFilled, DeleteOutlined } from "@ant-design/icons";

const { Title } = Typography;

const BackgroundSection = ({
  mode,
  selectedAssets = [],
  addFile,
  removeFile,
  setSelectedAssets,
  handleAddAsset,
}) => {

  const [newBackgroundName, setNewBackgroundName] = React.useState("");

console.log("selectedAssets>>>>>>>>>>>--", selectedAssets);

  const effectiveAssets = selectedAssets;

  console.log(
    "ASSET COUNT:",
    selectedAssets.length
  );
  
  console.log(
    "ASSETS:",
    JSON.stringify(selectedAssets, null, 2)
  );


  const handleBackgroundNameChange = (assetIndex, bgIndex, value) => {
    setSelectedAssets((prev) => {
      const updated = [...prev];

      updated[assetIndex].data[bgIndex].name = value;

      return updated;
    });
  };

  effectiveAssets.forEach((a, i) => {
    console.log("asset", i, a);
    console.log("backgrounds", a.backgrounds);
  });

  return (
    <Card className="editorContainer" bordered>
      <Title level={4}>Illusmaker - Hintergründe Ressourcen</Title>
      <div className="characters" style={{ marginBottom: 16 }}>


        {/* --------------------------------------------------
      CREATE NEW BACKGROUND CONTAINER
      -------------------------------------------------- */}
        <Input
          placeholder="Name der Hintergrund-Gruppe"
          value={newBackgroundName}
          onChange={(e) => setNewBackgroundName(e.target.value)}
          style={{ marginBottom: 12 }}
        />

        <Button
          type="primary"
          icon={<PlusCircleFilled />}
          disabled={!newBackgroundName.trim()}
          onClick={() => {
            const name = newBackgroundName.trim();

            if (!name) return;

            handleAddAsset(
              2,
              name,
              "/assets/images/background_ico2.png"
            );

            setNewBackgroundName(""); // reset input
          }}
          style={{ marginBottom: 16, height: 40, width: 300, alignSelf: "flex-end" }}
        >
          Neue Hintergrund-Gruppe
        </Button>

      </div>

      {/* --------------------------------------------------
      RENDER ALL TYPE 2 ASSETS
  -------------------------------------------------- */}
      {effectiveAssets
        .map((asset, index) =>
          asset.type === 2 ? (
            <Card
              key={`background-${index}`}
              style={{ marginBottom: 16 }}
              bordered
            >
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  <Title level={4}>
                    {asset.name || "Unbenannte Hintergrund-Gruppe"}
                  </Title>

                  {/* FILE GRID */}
                  <div
                    style={{
                      marginTop: 12,
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "12px",
                    }}
                  >
                    {asset.data?.map((bg, bgIndex) => (
                      <div
                        key={bgIndex}
                        style={{
                          border: "1px solid #ddd",
                          padding: 10,
                          borderRadius: 8,
                          width: 180,
                        }}
                      >
                        <img
                          src={bg.url}
                          alt={bg.name}
                          style={{
                            width: "100%",
                            height: 100,
                            objectFit: "cover",
                            marginBottom: 8,
                          }}
                        />

                        <Input
                          value={bg.name}
                          placeholder="Background name"
                          onChange={(e) =>
                            handleBackgroundNameChange(
                              index,
                              bgIndex,
                              e.target.value
                            )
                          }
                        />

                        <Button
                          danger
                          icon={<DeleteOutlined />}
                          onClick={() => removeFile(index, bgIndex)}
                          style={{ marginTop: 8 }}
                        />
                      </div>
                    ))}
                  </div>

                  {/* UPLOAD */}
                  <Upload
                    accept="image/*"
                    multiple
                    showUploadList={false}
                    beforeUpload={(file) => {
                      addFile(file, index);
                      return false;
                    }}
                  >
                    <Button icon={<PlusCircleFilled />}>
                      Hintergründe hinzufügen
                    </Button>
                  </Upload>
                </Col>
              </Row>
            </Card>
          ) : null
        )}
    </Card>
  );
};

export default BackgroundSection;